import { render, staticRenderFns } from "./BackerCenterProjectsView.vue?vue&type=template&id=03076bc8"
import script from "./BackerCenterProjectsView.vue?vue&type=script&lang=js"
export * from "./BackerCenterProjectsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports